/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GlobalAlarms } from '../models/global-alarms';
import { DashboardCommon } from '../models/dashboard-common';
import { DashboardCustomer } from '../models/dashboard-customer';
import { ReservoirSummary } from '../models/reservoir-summary';
import { FlowRates } from '../models/flow-rates';
import { WeatherStation } from '../models/weather-station';
import { ScheduleRequirements } from '../models/schedule-requirements';
import { Usage } from '../models/usage';
@Injectable({
  providedIn: 'root',
})
class EucsDashboardService extends __BaseService {
  static readonly EucsDashboardGetGlobalAlarmsPath = '/api/eucs/EucsDashboard/GetGlobalAlarms';
  static readonly EucsDashboardGetDashboardCommonPath = '/api/eucs/EucsDashboard/GetDashboardCommon';
  static readonly EucsDashboardGetMeterDetailsPath = '/api/eucs/EucsDashboard/GetMeterDetails';
  static readonly EucsDashboardGetReservoirUsagesPath = '/api/eucs/EucsDashboard/GetReservoirUsages';
  static readonly EucsDashboardGetFlowRatesPath = '/api/eucs/EucsDashboard/GetFlowRates';
  static readonly EucsDashboardGetWeatherStationDataPath = '/api/eucs/EucsDashboard/GetWindData';
  static readonly EucsDashboardGetScheduleRequirementsPath = '/api/eucs/EucsDashboard/GetScheduleRequirements';
  static readonly EucsDashboardGetCustomerUsagesPath = '/api/eucs/EucsDashboard/GetCustomerUsages';
  static readonly EucsDashboardControlEndpointPath = '/api/eucs/EucsDashboard/ControlEndpoint';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  EucsDashboardGetGlobalAlarmsResponse(): __Observable<__StrictHttpResponse<GlobalAlarms>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsDashboard/GetGlobalAlarms`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GlobalAlarms>;
      })
    );
  }  EucsDashboardGetGlobalAlarms(): __Observable<GlobalAlarms> {
    return this.EucsDashboardGetGlobalAlarmsResponse().pipe(
      __map(_r => _r.body as GlobalAlarms)
    );
  }
  EucsDashboardGetDashboardCommonResponse(): __Observable<__StrictHttpResponse<DashboardCommon>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsDashboard/GetDashboardCommon`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DashboardCommon>;
      })
    );
  }  EucsDashboardGetDashboardCommon(): __Observable<DashboardCommon> {
    return this.EucsDashboardGetDashboardCommonResponse().pipe(
      __map(_r => _r.body as DashboardCommon)
    );
  }
  EucsDashboardGetMeterDetailsResponse(): __Observable<__StrictHttpResponse<Array<DashboardCustomer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsDashboard/GetMeterDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DashboardCustomer>>;
      })
    );
  }  EucsDashboardGetMeterDetails(): __Observable<Array<DashboardCustomer>> {
    return this.EucsDashboardGetMeterDetailsResponse().pipe(
      __map(_r => _r.body as Array<DashboardCustomer>)
    );
  }
  EucsDashboardGetReservoirUsagesResponse(): __Observable<__StrictHttpResponse<Array<ReservoirSummary>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsDashboard/GetReservoirUsages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReservoirSummary>>;
      })
    );
  }  EucsDashboardGetReservoirUsages(): __Observable<Array<ReservoirSummary>> {
    return this.EucsDashboardGetReservoirUsagesResponse().pipe(
      __map(_r => _r.body as Array<ReservoirSummary>)
    );
  }
  EucsDashboardGetFlowRatesResponse(): __Observable<__StrictHttpResponse<FlowRates>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsDashboard/GetFlowRates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FlowRates>;
      })
    );
  }  EucsDashboardGetFlowRates(): __Observable<FlowRates> {
    return this.EucsDashboardGetFlowRatesResponse().pipe(
      __map(_r => _r.body as FlowRates)
    );
  }
  EucsDashboardGetWeatherStationDataResponse(): __Observable<__StrictHttpResponse<Array<WeatherStation>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsDashboard/GetWindData`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<WeatherStation>>;
      })
    );
  }  EucsDashboardGetWeatherStationData(): __Observable<Array<WeatherStation>> {
    return this.EucsDashboardGetWeatherStationDataResponse().pipe(
      __map(_r => _r.body as Array<WeatherStation>)
    );
  }
  EucsDashboardGetScheduleRequirementsResponse(): __Observable<__StrictHttpResponse<ScheduleRequirements>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsDashboard/GetScheduleRequirements`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ScheduleRequirements>;
      })
    );
  }  EucsDashboardGetScheduleRequirements(): __Observable<ScheduleRequirements> {
    return this.EucsDashboardGetScheduleRequirementsResponse().pipe(
      __map(_r => _r.body as ScheduleRequirements)
    );
  }
  EucsDashboardGetCustomerUsagesResponse(): __Observable<__StrictHttpResponse<Array<Usage>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsDashboard/GetCustomerUsages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Usage>>;
      })
    );
  }  EucsDashboardGetCustomerUsages(): __Observable<Array<Usage>> {
    return this.EucsDashboardGetCustomerUsagesResponse().pipe(
      __map(_r => _r.body as Array<Usage>)
    );
  }

  /**
   * @param params The `EucsDashboardService.EucsDashboardControlEndpointParams` containing the following parameters:
   *
   * - `expiration`:
   *
   * - `endpointId`:
   *
   * - `command`:
   */
  EucsDashboardControlEndpointResponse(params: EucsDashboardService.EucsDashboardControlEndpointParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.expiration != null) __params = __params.set('expiration', params.expiration.toString());
    if (params.endpointId != null) __params = __params.set('endpointId', params.endpointId.toString());
    if (params.command != null) __params = __params.set('command', params.command.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/eucs/EucsDashboard/ControlEndpoint`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `EucsDashboardService.EucsDashboardControlEndpointParams` containing the following parameters:
   *
   * - `expiration`:
   *
   * - `endpointId`:
   *
   * - `command`:
   */
  EucsDashboardControlEndpoint(params: EucsDashboardService.EucsDashboardControlEndpointParams): __Observable<null> {
    return this.EucsDashboardControlEndpointResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module EucsDashboardService {

  /**
   * Parameters for EucsDashboardControlEndpoint
   */
  export interface EucsDashboardControlEndpointParams {
    expiration?: string;
    endpointId?: number;
    command?: null | boolean;
  }
}

export { EucsDashboardService }
